/*LIBRARY*/

/*COMPONENT*/
import ErrorFreeKai from "../user/ErrorFreeKai";
import NO_LICENSE from "./NO_LICENSE";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import domain_list from "../../Data/domain_list";

/*CONST*/

const NO_LICENSE_HANDLE = () => {
  //local storage

  //local state
  const domain_w_port = window.location.host;
  const is_domain_kai = domain_list[domain_w_port]?.is_domain_kai;

  //global props

  //content
  let content = null;
  if (is_domain_kai) {
    content = <ErrorFreeKai />;
  } else {
    content = <NO_LICENSE />;
  }

  return <main>{content}</main>;
};

export default NO_LICENSE_HANDLE;
